import React from 'react'

import dynamic from 'next/dynamic'

interface LottieWrapperProps {
  animationData: any
  height?: number | string
  width?: number | string
  style?: React.CSSProperties
  [key: string]: any
}

// Create a completely SSR-safe lottie component
const LottiePlayer = dynamic(
  async () => {
    // Only load the actual lottie component on the client side
    if (typeof window === 'undefined') {
      // Return a dummy component for SSR
      return {
        default: (props: LottieWrapperProps) => (
          <div style={props.style}>Loading animation...</div>
        ),
      }
    }

    // Only import lottie on the client side
    const LottieComponent = await import('lottie-light-react')
    return { default: LottieComponent.default }
  },
  {
    ssr: false,
    loading: () => <div>Loading animation...</div>,
  },
)

export const LottieWrapper: React.FC<LottieWrapperProps> = (props) => {
  return <LottiePlayer {...props} />
}

export default LottieWrapper
